import React, { ReactNode } from "react";
import styled, { css } from "styled-components";
import { Theme, colors, ColorsKey } from "@literati/public-ui-shared-react";

export type CurvatureScale = 1 | 2 | 3 | 4 | 5;
export type TopOffset = `${number}px`;

export interface RadialBackgroundProps {
  bottomColor: keyof typeof colors;
  children: ReactNode;
  className?: string;
  curvature?: CurvatureScale;
  top: TopOffset;
  topColor: ColorsKey;
}

const StyledDiv = styled.div<{
  $bottomColor: keyof typeof colors;
  $curvature: CurvatureScale;
  $top: TopOffset;
  $topColor: ColorsKey;
}>`
  position: relative;
  width: 100vw;

  ${({ $bottomColor, $curvature, $top, $topColor }) => css`
    background: radial-gradient(
      calc(100vw + ${$curvature}00px) 140% at top ${$top} left 50%,
      ${colors[$bottomColor]} 50%,
      ${colors[$topColor]} 50%,
      ${colors[$topColor]} 100%
    );
  `}
`;

/**
 * Meant to be used as a full viewport width background.
 *
 * @note Styles are opinionated based on designs, but allow for
 * customization of colors and top offset in px.
 *
 * @see OnboardingConfirmationContent.tsx for example usage
 */
export const RadialBackground = ({
  bottomColor,
  children,
  className = "",
  curvature = 4,
  top,
  topColor,
}: RadialBackgroundProps) => {
  return (
    <Theme>
      <StyledDiv
        $bottomColor={bottomColor}
        className={className}
        $curvature={curvature}
        $top={top}
        $topColor={topColor}
      >
        {children}
      </StyledDiv>
    </Theme>
  );
};

export default RadialBackground;
